import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { JobAction } from 'src/app/core/models/job';
import { Node, NodeAction } from 'src/app/core/models/node';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { NodeService } from 'src/app/core/services/node.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-node-advance-view',
  templateUrl: './node-advance-view.component.html',
  styleUrl: './node-advance-view.component.scss'
})
export class NodeAdvanceViewComponent {

  private nodeService = inject(NodeService);
  private route = inject(ActivatedRoute);
  private storageService = inject(StorageService);
  private env = inject(EnvironmentService);
  private router = inject(Router);

  @Output() hideDetails = new EventEmitter();
  @ViewChild(MatSort) sort: MatSort;
  
  selectedNode: Node = this.nodeService.activeNode;
  currentStorageName: string = this.storageService.getActiveStorageName();
  allowAdminJobActionsToUsers = this.env.envVariables.allowAdminJobActions;
  cloudType: string = this.route.snapshot.params["cloudType"] || this.route.parent.snapshot.params["cloudType"];
  syncStoreUsage: null;
  workStoreUsage: null;
  jobSyncDir: any;
  toShow: boolean;
  jobWorkDir: any;
  jobs: any;
  jobNodeName:string;
  active = 1;
  jobActions = [];
  autoRescaleFlag: boolean;
  destroy$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.nodeService.SelectedNode.pipe(takeUntil(this.destroy$), filter(x => x != null)).subscribe((data) => {
      this.selectedNode = this.nodeService.activeNode;
    })
    this.openDetails();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.nodeService.updateNodeAction(null);
    this.hideDetails.emit('true');
  }

  emitNodeAction(action: NodeAction) {
    let nodeObj = {
      action: action,
      node: this.selectedNode
    }
    this.nodeService.updateNodeAction(nodeObj);
  }

  openDetails(){
    this.router.navigate([this.selectedNode.vmName, "Details"], { relativeTo: this.route });
    this.active = 1;
  }
}
